import { Row, Button, Form, Col } from "react-bootstrap";
import { RootState } from "redux/store";
import { useCallback, useEffect, useRef, useState } from "react";
import { BulkEdit } from "./Popups/BulkEdit";
import { Spinner, Table, Modal, TooltipIcon } from "components";
import { getStores } from "redux/slices/Stores";
import { useDisplayError } from "helpers/Functions";
import { getDepartments } from "redux/slices/Departments";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { displayTooltipsIcons } from "helpers/data/dataHandling";
import { updateAssignPriceGroupField, getPriceGroupsStore, bulkUpdatePriceGroupsStore, GetCurrentPriceGroup, applyPriceGroupsStore, updateAssignPriceGroupTableField, addAGGridSelectedStores } from "redux/slices/AssignPriceGroup";
import { AgGridReact } from "ag-grid-react";
import { getPriceGroupDepartmentConfig } from "TableConfigs/PriceGroupDepartmentConfig";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { AgGridToolbar } from "components/AgGrid/AgGridToolbar";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";
import { showToast } from "redux/slices/Toasts";

type departmentProps = {
    display: boolean;
    updateTab: (tab: string) => void;
}

export default function DepartmentPriceGroup({ display, updateTab }: departmentProps) {
    const dispatch = useAppDispatch();
    const displayError = useDisplayError();
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bulkEditShow, setBulkEditShow] = useState(false);
    const [disableModal, setDisableModal] = useState(false);
    const stores = useAppSelector((state: RootState) => state.stores);
    const priceGroups = useAppSelector((state: RootState) => state.priceGroups);
    const assignPriceGroup = useAppSelector((state: RootState) => state.assignPriceGroup);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const departmentPriceGroupGridRef = useRef<AgGridReact>(null);

    function moveToStocks(departmentId: number) {
        updateTab("3");
        dispatch(updateAssignPriceGroupField({ key: "currentDepartment", value: departmentId }));
        dispatch(updateAssignPriceGroupField({ key: "currentDepartmentPriceGroup", value: GetCurrentPriceGroup(assignPriceGroup.currentStore) }));
    }

    useEffect(() => {
        dispatch(getStores({}));
    }, []);

    useEffect(() => {
        if (display === true && assignPriceGroup.currentStore > 0 && assignPriceGroup.activeTab === 2) getDepartmentsList();
        if (assignPriceGroup.currentStore == 0 && departmentPriceGroupGridRef.current != null && departmentPriceGroupGridRef.current?.api != undefined && assignPriceGroup.activeTab === 2){
            dispatch(showToast({ value: ["Please select a store to continue."] }));            
            departmentPriceGroupGridRef.current?.api.showNoRowsOverlay();           
        }
    }, [assignPriceGroup.currentStore, display, assignPriceGroup.activeTab]);

    async function getDepartmentsList() {
        if (assignPriceGroup.currentStore > 0) {
            setLoading(true);
            await dispatch(getDepartments());
            if (stores.table.length > 0) {
                await dispatch(getPriceGroupsStore({
                    storeIds: [assignPriceGroup.currentStore],
                    groupBy: "Departments"
                })).then((res) => {
                    if (res.data) {
                        let departments: any[] = [];
                        let departmentIds: any[] = [];
                        res.data.forEach((department: any) => {
                            if (!departmentIds.includes(department.departmentId)) {
                                departments.push(department);
                                departmentIds.push(department.departmentId);
                            }
                        });
                        dispatch(updateAssignPriceGroupField({ key: "departments", value: departments }));
                    }
                    if(res.totalRows == 0){
                        departmentPriceGroupGridRef.current?.api.showNoRowsOverlay();
                    }
                });
            } else {
                departmentPriceGroupGridRef.current?.api.showNoRowsOverlay();
            }
            setLoading(false);
        } else {
            departmentPriceGroupGridRef.current?.api.showNoRowsOverlay();
        }
    }

    async function handleSubmit() {
        setDisableModal(true);
        setSaving(true);
        let managedDepartmentIds: number[] = [];
        if (assignPriceGroup.selecetedDepartments.length === 0) {
            managedDepartmentIds = assignPriceGroup.departments.map((department: any) => department.departmentId);
        } else {
            //@ts-ignore
            managedDepartmentIds = assignPriceGroup.selecetedDepartments.map((departmentId: number) => assignPriceGroup.departments[departmentId].departmentId);
        }
        let payload: any = {
            filter: {
                storeIds: [assignPriceGroup.currentStore],
                managedDepartmentIds: managedDepartmentIds,
            },
            sync: true,
        }
        // console.log("payload", payload);
        await dispatch(applyPriceGroupsStore(payload)).then((res) => {
            setShowModal(false);
            setDisableModal(false);
            setSaving(false);

            if (res.data) {
                getDepartmentsList();
            }
        });
    }

    async function bulkUpdateDepartmentPriceGroups(departmentId: number[], newPriceGroupId: number, storeIds: number[]) {
        await dispatch(bulkUpdatePriceGroupsStore({
            managedStockFilter: {
                departmentIds: departmentId,
            },
            newPriceGroupId: newPriceGroupId,
            storeIds: storeIds
        })).then((res) => {
        }).catch((error: any) => {
            displayError(error);
        });
    }

    function getPriceGroupName(currentStore: number) {
        let priceGroupName = "";
        assignPriceGroup.stores.forEach((store: any) => {
            if (store.storeId === currentStore) priceGroupName = store.priceGroupName;
        });
        dispatch(updateAssignPriceGroupField({ key: "currentStorePriceGroup", value: priceGroupName }));
    }

    async function saveBulkEdit(priceGroupId: number) {
        //@ts-ignore
        const storeIds = assignPriceGroup.selectedStores.map((storeId: number) => assignPriceGroup.stores[storeId].storeId);
        let managedDepartmentIds: number[] = [];
        if (assignPriceGroup.selecetedDepartments.length === 0) {
            managedDepartmentIds = assignPriceGroup.departments.map((department: any) => department.departmentId);
        } else {
            //@ts-ignore
            managedDepartmentIds = assignPriceGroup.selecetedDepartments.map((departmentId: number) => assignPriceGroup.departments[departmentId].departmentId);
        }
        await bulkUpdateDepartmentPriceGroups(managedDepartmentIds, priceGroupId, [assignPriceGroup.currentStore]);
        await getDepartmentsList();
        setBulkEditShow(false);
    }

    return (
        <>
            <Row className="mb-2">
                <Col xs={3}>
                    <Form.Group>
                        <div className="" style={{ display: "flex" }}>
                            <Col xs={11}>
                                <Form.Label className="form-check-label">Store</Form.Label>
                                <Form.Select
                                    className="custom-select"
                                    value={assignPriceGroup.currentStore}
                                    onChange={(e) => {
                                        dispatch(updateAssignPriceGroupField({ key: "currentStore", value: parseInt(e.target.value) }));
                                        getPriceGroupName(parseInt(e.target.value));
                                    }}
                                >
                                    <option hidden value="0">Choose a Store</option>
                                    {stores.table.map((priceLevel: any, index: any) => {
                                        return <option key={index} value={priceLevel.id}>{priceLevel.name}</option>
                                    })}
                                </Form.Select>
                            </Col>
                            <Col xs={1} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }} className="d-flex ">
                                <div className="m1" style={{ marginBottom: "4px" }}>
                                    <TooltipIcon text="Showing departments with stock lines" placement="right" />
                                </div>
                            </Col>
                        </div>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    {bulkEditShow &&
                        <BulkEdit
                            show={bulkEditShow}
                            saveSelected={saveBulkEdit}
                            handleClose={() => setBulkEditShow(false)}
                            count={assignPriceGroup.selecetedDepartments.length}
                        />}
                    <Modal
                        title="Confirm - Department level"
                        show={showModal}
                        buttonType="primary"
                        disableButtons={disableModal}
                        buttonText={disableModal ? "Applying..." : "Continue"}
                        handleClose={() => setShowModal(false)}
                        handleSubmit={handleSubmit}
                        description={
                            <>
                                <p>You are about to apply the new price group and sync the new sell prices.</p>
                                <p>Are you sure you want to continue?</p>
                            </>
                        }
                    />
                    <AgGridToolbar
                        search={true}
                        className="pb-1"
                        handleSubmit={(searchState, filterState) => {
                            departmentPriceGroupGridRef.current?.api.clearRangeSelection();
                            dispatch(addAGGridSelectedStores([]));
                            departmentPriceGroupGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);
                        }}
                        searchProps={
                            {totalRows: assignPriceGroup.departments.length, placeholder: "by Name", hideContains: true}
                        }
                        children={(
                            <div className="d-inline-flex gap-1">
                                { 
                                (assignPriceGroup.selecetedDepartments != undefined && assignPriceGroup.selecetedDepartments.length != 0) &&									
                                    <Z.Button variant="light" className="h-100" disabled={true} buttonText={assignPriceGroup.selecetedDepartments.length + " Selected"}/>
                                }
                                {assignPriceGroup.selecetedDepartments.length > 1 &&
                                    <Button variant="light" className="me-1" onClick={() => setBulkEditShow(true)}> <i className="mdi mdi-pencil"></i> Bulk Edit</Button>
                                }                    
                                <ZTooltip text="Refresh">
                                    <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => getDepartmentsList()} disabled={!user.permissions.priceGroups.canView} />
                                </ZTooltip>
                            </div>
                        )}
                    />
                    <AgGridReact
                        ref={departmentPriceGroupGridRef}                                    
                        columnDefs={getPriceGroupDepartmentConfig(assignPriceGroup, user, priceGroups)}
                        rowData={ assignPriceGroup.departments != undefined && assignPriceGroup.departments.length != 0? assignPriceGroup.departments: null }
                        pagination={true}
                        paginationPageSize={20}
                        containerStyle={{ height: "70dvh" }}
                        className="ag-theme-quartz ag-theme-custom w-100"
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        suppressContextMenu
                        onSelectionChanged={(e) => {
                            let formatedData:{
                                positon: number,
                                id: number
                            } [] = []
                            departmentPriceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                            dispatch(addAGGridSelectedStores(formatedData));
                        }}
                        onRowSelected={() => {
                            let formatedData:{
                                positon: number,
                                id: number
                            } [] = []
                            departmentPriceGroupGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
                            dispatch(addAGGridSelectedStores(formatedData));
                        }}
                        components={{
                            baseCellRenderer: BaseCellRenderer,
                        }}
                        onCellClicked={(cell: any)=>{
                            if(cell.column.getColId() == "departmentName"){
                                moveToStocks(cell.data.departmentId);
                            }                       
                        }}
                    />                    
                </Col>
            </Row>
            <Row className="mt-3 mb-2">
                <Col sm={6}>
                </Col>
                <Col sm={6} className="d-flex flex-row-reverse">
                    <Button variant="primary" className="btn ms-1 cta-button" onClick={() => { setShowModal(true); setDisableModal(false); }} disabled={!user.permissions.assignPriceGroups.canUpdate}>
                        {saving ? <Spinner className="spinner-border-sm me-1" tag="span" color="white" /> : null}
                        {saving ? "Applying..." : "Apply & Sync"}
                    </Button>
                    <Button variant="light" className="btn cta-button" onClick={() => dispatch(updateAssignPriceGroupField({ key: "activeTab", value: 3 }))}>Review Prices</Button>
                </Col>
            </Row>
        </>
    );
}